module.exports = __webpack_public_path__ + "static/enrique-8c935fe034ed6b98713f90a9dcd3038f.jpg";